import { formatCurrencyAsText, transformAsCurrency } from '~/utils/functions';

type AnyRecord = Record<string, any>;

const toNum = (value: unknown): number => {
  if (value === null || value === undefined) return 0;
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  if (typeof value === 'string') return transformAsCurrency(value);

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const endsWith556 = (cfop: unknown): boolean => {
  if (cfop === null || cfop === undefined) return false;

  const digits = String(cfop).replace(/\D/g, '');
  return digits.length >= 3 && digits.slice(-3) === '556';
};

const keepCurrencyString = (value: unknown): value is string =>
  typeof value === 'string';

export const applyCfop556Rule = <T extends AnyRecord>(
  item: T,
  tributacoesSelect?: any[],
  setValueFiscal?: any,
): T => {
  if (!endsWith556(item?.cfop)) return item;

  const qtdEmbalagem = toNum(item.qtd_embalagem);
  const qtdTotal = toNum(item.qtd_total);

  let valUnitario = toNum(item.val_unitario ?? item.val_unit);

  if (valUnitario <= 0) {
    const valTotal = toNum(item.val_total);
    if (qtdEmbalagem > 0 && qtdTotal > 0) {
      const qtdEmbalagens = qtdTotal / qtdEmbalagem;
      if (qtdEmbalagens > 0) valUnitario = valTotal / qtdEmbalagens;
    }
  }

  const computedOutros =
    qtdEmbalagem > 0 && valUnitario > 0
      ? (qtdTotal / qtdEmbalagem) * valUnitario
      : toNum(item.val_outros);

  let codTributacao = toNum(item.cod_tributacao);
  let desTributacao = item.des_tributacao;

  if (tributacoesSelect && setValueFiscal) {
    const tributacao = tributacoesSelect.find(
      (t: any) => String(t.cst) === '090',
    );
    if (tributacao) {
      setValueFiscal('tributacao', tributacao);
      codTributacao = toNum(tributacao.value);
      desTributacao = tributacao.label;
    }
  }

  return {
    ...item,
    val_bc_icms: keepCurrencyString(item.val_bc_icms) ? '0,000' : 0,
    val_icms: keepCurrencyString(item.val_icms) ? '0,00' : 0,
    val_outros: keepCurrencyString(item.val_outros)
      ? formatCurrencyAsText(computedOutros)
      : computedOutros,
    cod_sit_tributaria: '090',
    cod_tributacao: codTributacao,
    des_tributacao: desTributacao,
  };
};
